module.exports = __webpack_public_path__ + "img/icon-srd.948513ef.svg";